import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import HeaderApp from "@/components/header/Header.vue";
import SidebarApp from "@/components/sidebar/Sidebar.vue";
import { IUser } from "@/models";

@Component({
    name: "app",
    components: {
        HeaderApp,
        SidebarApp,
    },
})
export default class App extends Vue {

    private promises: Array<Promise<any>>;

    constructor() {
        super();

        this.promises = [];
        if (!this.$store.state.app.user) {
            this.promises.push(this.$store.dispatch("app/getUser"));
        }

        if (this.$store.state.app.applicationVersion === null ||
            this.$store.state.app.applicationVersion === undefined) {
            this.promises.push(this.$store.dispatch("app/fetchApplicationVersion"));
        }
    }

    public get isAuthenticated(): boolean {
        return this.$store.getters["app/isAuthenticated"];
    }

    public get user(): IUser {
        return this.$store.state.app.user;
    }

    public get version(): string {
        return this.$store.getters["app/applicationVersion"];
    }

     // Hook.
     public async created(): Promise<void> {
        await Promise.all(this.promises);
    }
}
